<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div fxLayout="column" fxLayoutGap="16px" class="wrapper">
  <h1 class="mat-headline-4">Integrations</h1>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Principle Bridge</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <pr-practice-bridge-settings [practice]="practice$ | async" />
    </mat-card-content>
  </mat-card>

  <ng-container *prIsRegion="[region.Australia]">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>Tyro</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <pr-practice-tyro-settings [practice]="practice$ | async" />
      </mat-card-content>
    </mat-card>

    <ng-container *ptFeatureEnabled="'hicaps-connect'">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>HICAPS</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <pr-practice-hicaps-connect-settings [practice]="practice$ | async" />
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>

  <ng-container *prIsRegion="[region.NewZealand]">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>Smartpay</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <pr-practice-smartpay-settings [practice]="practice$ | async" />
      </mat-card-content>
    </mat-card>
  </ng-container>

  @if (verifoneEnabled$ | async) {
    <mat-card *prIsRegion="[region.NewZealand]" appearance="outlined">
      <mat-card-header>
        <mat-card-title>Verifone</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <pr-practice-verifone-settings [practice]="practice$ | async" />
      </mat-card-content>
    </mat-card>
  }

  <ng-container *ptFeatureEnabled="aiNotesFeature">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>Heidi Health</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <pr-practice-heidi-settings [practice]="practice$ | async" />
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *prIsRegion="[region.NewZealand]">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>Ministry of Health</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <pr-practice-moh-settings [practice]="practice$ | async" />
      </mat-card-content>
    </mat-card>
  </ng-container>

  <mat-card *prIsRegion="[region.NewZealand]" appearance="outlined">
    <mat-card-header>
      <mat-card-title>ACC</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <pr-practice-acc-settings [practice]="practice$ | async" />
    </mat-card-content>
  </mat-card>
</div>
